import React from "react"

import { LoadingOutlined } from "@ant-design/icons"
import { Spin, type SpinProps } from "antd"

export const SpinnerElement: React.FunctionComponent<ISpinnerElementProps> = ({
    containerClassName,
    loadingOutlinedIndicator,
    loadingOutlinedIndicatorFontSize,
    size,
    indicator,
    ...spinProps
}) => {
    return (
        <div className={containerClassName}>
            <Spin
                size={size || "large"}
                indicator={
                    loadingOutlinedIndicator ? (
                        <LoadingOutlined
                            style={{
                                fontSize:
                                    loadingOutlinedIndicatorFontSize || 33,
                            }}
                            spin
                        />
                    ) : (
                        indicator
                    )
                }
                {...spinProps}
            />
        </div>
    )
}

interface ISpinnerElementProps extends SpinProps {
    containerClassName?: string
    loadingOutlinedIndicator?: boolean
    loadingOutlinedIndicatorFontSize?: number
}
